import React from 'react';

import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Typography from 'material-ui/Typography';

import Button from 'material-ui/Button';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Select from 'material-ui/Select';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormControlLabel} from 'material-ui/Form';

import {DatePicker} from 'material-ui-pickers';

import Grid from 'material-ui/Grid';

import {FilterList, ArrowDownward, ArrowUpward} from 'material-ui-icons';

import tsl from './../../../tsl';

import axios from 'axios';

export default class Filter extends React.Component {

  state = {
    filters: {
      location: [],
      dropoff_location: []
    },
    filter_displayed: false,
  };

  componentWillReceiveProps = (newProps) => {
    // this.setState({
    //   filters: newProps.filter,
    // });
  };

  componentDidMount() {

  }

  propagateChanges = (filter) => {
    this.props.onChange(filter);
    //console.log('filter state',this.state.filters);
  };

  filterChange = (name) => (e) => {
    //console.log(name, e.target.value);
    const target = e.target;

    this.setState(state => ({
        filters: {
          ...state.filters,
          [name]: target.value
        }
      }), () => {
        this.propagateChanges(this.state.filters);
      }
    );
  };

  filterCollapse = () => {
    this.setState({
      filter_displayed: !this.state.filter_displayed
    });
  };

  render() {
    console.log(this.state.filters);

    return (
      <ExpansionPanel expanded={this.state.filter_displayed} onChange={this.filterCollapse}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
          <FilterList/>
          <Typography>{tsl('flights.filter.header')}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>

          <Grid container spacing={8}>
            <Grid item sm={4} xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="location">{tsl('offers.edit.location')}</InputLabel>
                <Select
                  name="location"
                  multiple
                  value={this.state.filters.location || []}
                  onChange={this.filterChange('location')}
                >
                  {this.props.locations.map((loc) => {
                    return (<MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>);
                  })}
                </Select>
              </FormControl>
            </Grid>
            { this.props.dropoff &&

            <Grid item sm={4} xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="location">{tsl('offers.edit.dropoff_location')}</InputLabel>
                <Select
                  name="dropoff_location"
                  multiple
                  value={this.state.filters.dropoff_location || []}
                  onChange={this.filterChange('dropoff_location')}
                >
                  {this.props.locations.map((loc) => {
                    return (<MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>);
                  })}
                </Select>
              </FormControl>
            </Grid>
            }
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}


// WEBPACK FOOTER //
// ./app/used/offers/routes/Filter.js